import { BreadCrumb, SnackSimple } from '../../../../components'
import { useStyles } from './styles'
import { ExecutionBody } from './body'
import { Badge, Box, Button, IconButton, Typography } from '@mui/material'
import dayjs from 'dayjs'
import { Header } from '../detail/fragments'
import { SectionCard } from './components/sectionCard'
import { DinamicForm } from '../../../../components/dinamicForm'
import { Constants } from '../../../../utils/constants'
import { Information } from './components/information'
import Loader from '../../../../components/loader'
import { NoResponse } from '../../../../components/errors/noResponse'
import { icons } from '../../../../utils/icons'
import DownloadFiles from '../../../../components/donwloadFiles'
import { ModelDownloadButtons } from '../../../../components/donwloadFiles/model'
import { DataFlag } from '../../../../utils/enums/dataExistence'
import { ButtonExecution } from './components/buttonExecution'

const ExecutionDetail = () => {
  const styles = useStyles()

  return ExecutionBody({
    children: ({ queryv2, getVersionQuestionaire, downloadExtra, downloadMain, lastVersionId, handleLastVersionId, handleIconClick, versionsQuestionaire, headerConfig, header, sections, handleFlag, flagData, flag, input, errors, filterData, onChange, t, openDrawer, closeDrawer, showPettyCash, config, counter, cleanFilter }) => {
      return (

        <Box sx={styles.container}>
          <BreadCrumb />
          <SnackSimple
            close={downloadMain.closeOpenSnakbar}
            open={downloadMain.openSnackbar.open}
            type={downloadMain.openSnackbar.type}
            message={downloadMain.openSnackbar.message}
          />

          <SnackSimple
            close={downloadExtra.closeOpenSnakbar}
            open={downloadExtra.openSnackbar.open}
            type={downloadExtra.openSnackbar.type}
            message={downloadExtra.openSnackbar.message}
          />

          <Box sx={styles.flex}>
            <Typography variant='title_grey_big' sx={styles.title}>{t('Questionarie.detailOfQuestionnaireExecution')}</Typography>
            <Box>
              <Typography sx={styles.date}>{headerConfig.date ? dayjs(headerConfig.date).format(Constants.dayjsFormatDate) : 'N/A'}</Typography>
              <Typography>{t('Questionarie.startDate')}</Typography>
            </Box>
          </Box>

          <Box sx={styles.flex}>
            <Box sx={styles.mainCash}>
              <Box sx={styles.header}>
                <Header
                  averagePoints={header?.averagePoints ?? 0}
                  dataHeader={header?.dataHeader}
                  actionPlan={Boolean(header?.dataHeader?.option == '0')}
                  handleNavigate={() => { }}
                  isSectionConfig={Boolean(header?.isSectionConfig)}
                  openGeneralConfig={openDrawer}
                  view="execution"
                  questionaireVersion={versionsQuestionaire.slice().reverse()}
                  handleLastVersionId={handleLastVersionId}
                  lastVersionId={lastVersionId}
                />
              </Box>
              <Box sx={{ ...styles.flex, ...styles.structure }}>
                <Typography variant='title_grey_big' sx={styles.title}>{t('Questionarie.questionnaireStructure')}</Typography>
                <Box sx={styles.flex}>
                  {/* <Button onClick={downloadMain.downloadCSV} sx={styles.button}>{t('general.download')} PDF</Button> */}
                  <ModelDownloadButtons
                    customeLabels={{
                      csv: t('Questionarie.csvExecution'),
                      pdf: t('Questionarie.pdfExecution'),
                    }}
                    csv={downloadMain.downloadCSV}
                    pdf={downloadMain.downloadPDF}
                    word={downloadMain.downloadWORD}
                    disableCSV={downloadMain.download?.excel}
                    disablePDF={downloadMain.download?.pdf}
                    disableWORD={downloadMain.download?.word}
                    styleType
                    disableTypes={['word']}
                    extraDownload={
                      [
                        {
                          disable: downloadExtra.download.excel,
                          dowload: () => { downloadExtra.downloadCSV() },
                          label: 'Questionarie.csvAnswer',
                          type: 'csv'
                        }
                      ]
                    }
                  />
                  <Badge badgeContent={counter} color="primary" sx={styles.badge({ counter: counter })}>
                    <IconButton sx={{ ...styles.buttonBadge, ...(counter || 0) <= 0 && styles.hide }}
                      onClick={() => { handleIconClick() }}
                    >
                      {icons('clean')}
                    </IconButton>
                  </Badge>

                  <Button sx={styles.filter} onClick={handleFlag}>{t(`general.${flag ? 'hideFilters' : 'showFilters'}`)}</Button>
                </Box>
              </Box>
              <Box sx={styles.inputsForm({ flag })}>
                <DinamicForm errors={errors} input={Object.values(input)} values={filterData} onChange={onChange} justifyContentLeft spacing={{ row: 3, column: 3 }} />
                {/* <Box sx={styles.containerButoon}>
                  <ButtonExecution counter={counter} cleanFilter={cleanFilter} queryv2={queryv2} getVersionQuestionaire={getVersionQuestionaire} />
                </Box> */}
              </Box>
              <Box sx={styles.questionsContainer}>
                {!!(flagData === DataFlag.LOADING) && <Loader />}
                {!!(flagData === DataFlag.NODATA) &&
                  <Box sx={styles.marginTop}>
                    <NoResponse label={t('reportFolio.detail.general.noInformation')} />
                  </Box>
                }
                {sections?.map((section, index) => (
                  <SectionCard key={index} title={section.title} percentage={section.percentage} sumCorrectOption={section.sumCorrectOption} totalScoreCorrect={section.totalScoreCorrect} questions={section.questions} totalPoints={section.totalPoints} />
                ))}
              </Box>
            </Box>
            <Box sx={styles.pettyCash}>
              <Information drawer={{ open: showPettyCash }} closeDrawer={closeDrawer} t={t} list={config} />
            </Box>
          </Box>
        </Box>
      )
    }
  })
}


export { ExecutionDetail }